import React from 'react';
import { Box } from '@mui/material';

type SvgIconType = {
  width?: string;
  height?: string;
  classes?: string;
  children: React.ReactElement;
};

export const SvgIconContainer = ({
  width,
  height,
  classes,
  children,
}: SvgIconType): React.ReactElement => (
  <Box
    display="inline-flex"
    justifyContent="center"
    alignItems="center"
    className={classes}
    height={height}
    width={width}
  >
    {children}
  </Box>
);

export default SvgIconContainer;
